import React from "react";
import Spinner from "../OnboardingComponents/Spinner";

const LoginLoadingInvite = () => {
  return (
    <div className="w-full max-w-sm flex flex-col items-center justify-center">
      <div className="flex items-center justify-center scale-[0.5] -my-10">
        <Spinner />
      </div>
      <h2 className="text-2xl font-semibold text-[#1f2937] mb-2 text-center">Loading your invitation</h2>
      <p className="text-sm text-gray-500 text-center">
        Redirecting you securely...
      </p>
    </div>
  );
};

export default LoginLoadingInvite;